import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import "../../assets/css/footer.css";
import "../../assets/css/landingpage.css";
import CardMedia from "@mui/material/CardMedia";
import FoldHands from "../../assets/images/Aboutusimageflodhand.png";
import { useTheme, useMediaQuery } from "@mui/material";
import OurMissionImage from "../../assets/images/OurMissionImage.svg";
import OurValues from "../../assets/images/ourvaluespng.png";
import AboutusGroup from "../../assets/images/AboutusGroupimage.svg";
import FounderMegaConnect from "../../assets/images/FounderMegaconnect.png";
import { IconButton } from "@mui/material";
import CEO from "../../assets/images/CeoMegaconnect.png";
import ProjectManager from "../../assets/images/projectmanagermegaconnect.png";
import CyberSecurity from "../../assets/images/CyberSecurityMegaconnect.png";
import secureRightTop from "../../assets/images/aboutussecurefuturerighttop.png";
import secureAboutLeft from "../../assets/images/aboutussecurefutureleftbottom.png";
import Innovation from "../../assets/images/innovation.png";
import Inclusivity from "../../assets/images/inclusivity.png";
import Excellence from "../../assets/images/excellence.png";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import { Link } from "react-router-dom";
import CardContent from "@mui/material/CardContent";
import Paper from "@mui/material/Paper";
import AboutMain from "../../assets/images/about-us-page-main.png";
import NavBarLandingPage from "./NavBarLandingPage";
import FooterLandingpage from "./FooterLandingpage";
import { styled } from "@mui/material/styles";
import PinkCircle from "../../assets/images/pinkcircledot.svg";
import AboutImage from "../../assets/images/AboutCompanyImage2.png";
import AboutUsImageLaptop from "../../assets/images/AboutUsImageLaptop1.svg";
import MomSonImage from "../../assets/images/MomSonImage.svg";
import TermsConditionVector from "../../assets/images/termsandconditionvector.png";
import CircularRound from "../../assets/images/circular lining.svg";
import AboutImageMedium from "../../assets/images/AboutCompanyImage.png";
import AboutUsSmallImage from "../../assets/images/AboutUsimageSmall.png";
import AboutUsExtraSmallImage from "../../assets/images/AboutUsextrasmallImage.png";
import AboutImageSmall from "../../assets/images/aboutImageSmaller.svg";
import AboutOurMissionImage from "../../assets/images/AboutOurMissionSmallImage.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import OurMissionSmall from "../../assets/images/ourmissionImageSmall.png";
import OurMissionExtraSmall from "../../assets/images/ourmissionextrasmallimage.png";
import MomSonImageSmall from "../../assets/images/MomSonImageSmall.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {
  AddBoxTwoTone,
  ArrowBack,
  ArrowForward,
  LinkedIn,
} from "@mui/icons-material";
// import './styles.css';

// import required modules
import { Pagination, Navigation } from "swiper/modules";
import TrendingSwiper from "./TrendingSwiper";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ourvaluestyle = {
  typography: {
    fontFamily: "Sofia Sans Extra Condensed",
    fontSize: "60px",
    fontWeight: 700,
    color: "#1E53E8",
    marginBottom: "20px",
    display: "flex",
  },
  greenCircle: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: "#C7F760",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#1E53E8",
    fontSize: "24px",
    fontWeight: "bold",
  },
  "@media (max-width: 1024px)": {
    marginBottom: "88px",
    fontSize: "38px",
  },
};
function AboutCompany() {
  const styles = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      textAlign: "left",
      fontWeight: 700,
      fontSize: "60px",

      "@media (max-width: 1024px)": {
        fontFamily: "Sofia Sans Extra Condensed",
        fontSize: "38px",
        fontStyle: "normal",
        // padding: "33px 40px",
        fontWeight: 700,
        lineHeight: "100%" /* 38px */,
        // font-variant: all-small-caps;
      },
    },
    // "@media (max-width: 768px)": {
    //   fontSize: "38px",
    //   padding: "15px 15px",
    // },
    // "@media (max-width: 600px)": {
    //   fontSize: "32px",
    //   padding: "10px 10px",
    // },
    // "@media (max-width: 491px)": {
    //   fontSize: "40px",
    //   textAlign: "left",
    // },

    // Other styles...
  };
  const OurMission = {
    typography: {
      fontFamily: "Sofia Sans Extra Condensed",
      textAlign: "left",
      fontWeight: 700,
      fontSize: "60px",
      "@media (max-width: 600px)": {
        fontSize: "32px", // Adjust the font size for smaller screens
        // textAlign: "center",
        // lineHeight: "60px",
      },
      "@media (max-width: 1024px)": {
        fontFamily: "Sofia Sans Extra Condensed",
        fontSize: "38px",
        fontStyle: "normal",
        padding: "28px 23px",
        fontWeight: 700,
        lineHeight: "100%" /* 38px */,
        // font-variant: all-small-caps;
      },
    },

    // Other styles...
  };
  const [swiperRef, setSwiperRef] = useState(null);

  const [swiperInstance, setSwiperInstance] = useState(null); // State variable to hold Swiper instance

  const handleSwiper = (swiper) => {
    setSwiperInstance(swiper); // Update state with Swiper instance
  };
  const otherStyles = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: "1.125rem",
      fontWeight: 400,
      lineHeight: "160%",
      textAlign: "left",
      letterSpacing: "0em",

      "@media (max-width: 600px)": {
        fontSize: "18px", // Adjust the font size for smaller screens
        textAlign: "center",
        // padding: "10px 10px",
      },
      "@media (max-width: 491px)": {
        fontSize: "14px", // Adjust the font size for smaller screens
        textAlign: "left",
        // padding: "10px 10px",
      },
      "@media (max-width: 1024px)": {
        marginTop: "-30px",
        fontSize: "1rem",
        fontStyle: "normal",
        // padding: "30px 31px",
        fontWeight: 400,
        padding: "20px 20px",
        lineHeight: "180%" /* 38px */,
        // font-variant: all-small-caps;
      },

      "@media (max-width: 768px)": {
        fontSize: "14px",
        padding: "15px 15px",
      },
    },
    // Other styles...
  };
  const ourmissionotherStyles = {
    typography: {
      fontFamily: "Roboto Flex",
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "160%",
      textAlign: "left",
      letterSpacing: "0em",

      "@media (max-width: 600px)": {
        fontSize: "18px", // Adjust the font size for smaller screens
        textAlign: "center",
      },
      "@media (max-width: 1024px)": {
        marginTop: "-25px",
        fontSize: 16,
        fontStyle: "normal",
        padding: "21px 22px",
        fontWeight: 400,
        lineHeight: "180%" /* 38px */,
        // font-variant: all-small-caps;
      },
      "@media (max-width: 768px)": {
        marginTop: "10px",
        fontSize: 12,
        // fontStyle: normal;
        fontWeight: 400,
        lineHeight: "202%" /* 38px */,
        // font-variant: all-small-caps;
      },
    },
    // Other styles...
  };
  const smallDescriptionText = {
    typography: {
      fontFamily: "Roboto Flex",

      "@media (max-width: 600px)": {
        fontSize: "12px",
        textAlign: "center",
      },
    },
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const images = [
    {
      id: 1,
      src: CEO,
      name: "Person 1",
      role: "Role 1",
      linkedin: "https://linkedin.com",
    },
    {
      id: 2,
      src: ProjectManager,
      name: "Person 2",
      role: "Role 2",
      linkedin: "https://linkedin.com",
    },
    {
      id: 3,
      src: CyberSecurity,
      name: "Person 3",
      role: "Role 3",
      linkedin: "https://linkedin.com",
    },
    {
      id: 4,
      src: FounderMegaConnect,
      name: "Person 4",
      role: "Role 4",
      linkedin: "https://linkedin.com",
    },
  ];

  // State to track current image index
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

  const [prevImageIndex, setPrevImageIndex] = React.useState(null);

  const handleNextImage = () => {
    if (currentImageIndex < images.length - 1) {
      setPrevImageIndex(currentImageIndex);
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }
  };

  const handlePrevImage = () => {
    if (currentImageIndex > 0) {
      setPrevImageIndex(currentImageIndex);
      setCurrentImageIndex(
        (prevIndex) => (prevIndex - 1 + images.length) % images.length
      );
    }
  };
  const isTablet = useMediaQuery("(max-width: 1024px)");
  return (
    <div>
      <NavBarLandingPage />

      <div className=" aboutCompany landing-page">
        {/* <img src={AboutMain} alt="" style={{width:"100%"}}/> */}
        <div class="About-company-section">
          {/* <img class='center-down' src={sevteen} alt="" />
        <img class="right" src={sixteen} alt="2" /> */}
          <div className="About-company-section-container">
            <div className="About-company-text">
              <Box
                sx={{
                  padding: "30px",
                  background: "#FFFFFF26",
                  borderRadius: "15px",
                  display: "flex",
                  "@media (max-width: 600px)": { padding: "0px" },
                  "@media (max-width: 1024px)": {
                    padding: "33.099px 31.523px",
                    gap: "7.881px",
                    alignSelf: "stretch",
                    borderRadius: "23.642px",
                  },
                }}
              >
                <Typography
                  sx={{
                    ...smallDescriptionText.typography,
                    fontWeight: 700,
                    lineHeight: "28px",
                    fontSize: "22px",
                    letterSpacing: "0.1em",
                    color: "#C7F760",
                    padding: "10px",
                    fontStyle: "normal",
                    textAlign: "left",
                    textTransform: "uppercase",
                    "@media (max-width: 1024px)": {
                      fontSize: "16px",
                      lineHeight: "22px",
                    },
                    "@media (max-width: 491px)": {
                      fontSize: "14px",
                      lineHeight: "23px",
                      textAlign: "left",
                      width: "100%",
                    },
                  }}
                >
                  Unveiling the Heart Of
                  <br />
                  Megaconnect
                </Typography>
              </Box>

              <Typography
                sx={{
                  ...styles.typography,

                  lineHeight: "100%",
                  color: "#fff",
                  marginTop: "50px",
                  "@media (max-width: 600px)": {
                    marginTop: "20px", // Adjust the font size for smaller screens
                    fontSize: "32px",
                    textAlign: "left",
                    lineHeight: "50px",
                  },
                  "@media (max-width: 1024px)": {
                    marginTop: "20px", // Adjust the font size for smaller screens
                    fontSize: "38px",
                    textAlign: "left",
                    lineHeight: "100%",
                  },
                  "@media (max-width: 491px)": {
                    fontSize: "40px",
                    textAlign: "left",
                    lineHeight: "100%",
                  },
                }}
              >
                {isTablet ? (
                  <>
                    EMPOWERING SUCCESS THROUGH&nbsp;
                    <span style={{ color: "#C7F760" }}>CLOUD INNOVATION!</span>
                    <img src={PinkCircle} alt="" />
                  </>
                ) : (
                  <>
                    EMPOWERING <br /> SUCCESS THROUGH{" "}
                    <span style={{ color: "#C7F760" }}>CLOUD INNOVATION!</span>
                    <img src={PinkCircle} alt="" />
                  </>
                )}
              </Typography>
              <Typography
                sx={{
                  ...smallDescriptionText.typography,
                  width: "100%",
                  lineHeight: "28px",
                  color: "#fff",
                  fontSize: "18px",
                  marginTop: "30px",
                  "@media (max-width: 600px)": {
                    textAlign: "left",
                    width: "100%",
                    lineHeight: "30px",
                    fontSize: "14px",
                  },
                  "@media (max-width: 1024px)": {
                    textAlign: "left",
                    width: "100%",
                    lineHeight: "160%",
                    fontSize: "16px",
                  },
                }}
              >
                We're MegaConnect Technologies, a passionate team dedicated to
                revolutionizing education and productivity through cutting-edge
                cloud solutions.
              </Typography>
              <img
                src={TermsConditionVector}
                alt=""
                style={{
                  position: "absolute",
                  bottom: "0",
                  right: "0",
                  zIndex: 0,
                }}
              />
            </div>
            <div className="About-company-text-image">
              <img src={AboutImage} alt="" width={"100%"} height={"100%"} />
            </div>
          </div>
        </div>

        <br />
        <br />

        {/* About us and our mission page */}
        <div className="About-us-section">
          <Box
            sx={{
              // padding: "2px 51px",
              background: "#fff",

              // "@media (max-width: 600px)": {
              //   padding: "10px",
              // },
              "@media (max-width: 1024px) ": {
                // padding: "30px 40px",
                // height: "auto",
                // width: "95%",
              },

              "@media (max-width: 491px)": {
                // padding: "0px 26px",
                // maxWidth: "100%",
              },
            }}
          >
            <Grid
              spacing={1}
              sx={{
                display: "flex",
                alignItems: "stretch",
                gap: "20px",
                marginLeft: "16px",
                justifyContent: "center",
                "@media (max-width: 600px)": {
                  flexDirection: "column-reverse",
                  justifyContent: "center",
                  marginLeft: "-10px",
                  gap: "10px",
                },
                "@media (max-width: 1024px) ": {
                  gap: "20px",
                  // padding: "0px 14px 30px 2px",
                  // marginLeft:"8px",
                  width: "100%",
                  height: "auto",
                },
                "@media (max-width: 491px) ": {
                  gap: "20px",

                  // marginLeft: "auto",
                  width: "100vw",
                  // height: "100%",
                  margin: "50px",
                  padding:"0px"
                },
              }}
            >
              <Grid item xs={12} md={6}>
                <picture>
                  {/* <source media="(max-width: 600px)" srcSet={AboutImageSmall} /> */}
                  {/* <source
                    media="(max-width: 791px)"
                    srcSet={AboutImageSmall}
                    className="Img-responsive-width"
                  /> */}
                  <source
                    media="(max-width: 600px)"
                    srcSet={AboutUsExtraSmallImage}
                    width="100%"
                    height="100%"
                  />
                  <source
                    media="(max-width: 1024px)"
                    srcSet={AboutUsSmallImage}
                    className="Img-responsive-width"
                  />

                  <img
                    src={AboutUsImageLaptop}
                    alt=""
                    className="Img-responsive-width"
                  />
                </picture>
                {/* <img src={AboutUsImageLaptop} alt="" className="Img-responsive-width" /> */}
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                sx={{
                  backgroundColor: "#F1F1F1",
                  borderRadius: "30px",
                  padding: "40px 60px",
                  "@media (max-width: 600px)": {
                    // padding: "0px",
                    // marginTop: "10px",
                    // marginLeft: "10px",
                  },
                  "@media (max-width: 1024px)": {
                    padding: "36px",
                    // marginTop: "80px",
                    width: "auto",
                    height: "auto",
                    marginLeft: "10px",
                  },

                  "@media (max-width:491px)": {
                    width: "100%",
                    marginLeft: "-6px",
                  },
                }}
              >
                <Typography
                  sx={{
                    ...styles.typography,
                    color: "#1E53E8",
                    "@media (max-width:491px)": {
                      fontSize: "40px",
                      textAlign: "left",
                    },
                    "@media (max-width:1024px)": {
                      textAlign: "left",
                    },
                  }}
                >
                  ABOUT US
                  <img src={PinkCircle} alt="" />
                </Typography>

                <Typography
                  sx={{
                    ...otherStyles.typography,
                    "@media (max-width:1024px)": {
                      marginTop: "10px",
                      padding: "0px",
                      textAlign: "left",
                    },
                  }}
                >
                  MegaConnect Technologies believes in the boundless potential
                  of the cloud. We're a passionate team crafting revolutionary
                  cloud solutions, from secure and accessible virtual machines
                  for students to powerful storage and collaboration tools for
                  businesses.
                </Typography>
              </Grid>
            </Grid>

            <br />
            
              <Grid
                spacing={1}
                sx={{
                  display: "flex",
                  alignItems: "stretch",
                  gap: "20px",
                  marginLeft: "25px",
                  "@media (max-width: 600px) ": {
                    flexDirection: "column",

                    width: "92%",
                    // margin: "40px",
                    marginLeft:"25px",
                    marginTop:"0px"
                  },
                  "@media (max-width: 491px)": {
                    flexDirection: "column",
                  },
                  "@media (max-width: 1024px) ": {
                    // padding: "0px 24px 0px 0px",
                    // marginTop: "-50px",
                    // marginLeft: "30px",
                    // marginBottom: "-30px",
                    // marginRight: "-16px",
                    // width: "100%",
                    // margin:"40px"
                  },
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={5}
                  sx={{
                    backgroundColor: "#F1F1F1",
                    borderRadius: "30px",
                    padding: "40px 60px",

                    "@media (max-width: 600px)": {
                      padding: "10px",
                      // flexDirection: "column-reverse",
                      marginRight: "9px",
                      width: "100%",
                    },
                    "@media (max-width: 1024px) and (min-width: 800px)": {
                      padding: "0px 0px",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      ...OurMission.typography,
                      textAlign: "left",
                      color: "#1E53E8",
                      // marginBottom: "20px", // Add margin bottom to create gap between headings and text
                    }}
                  >
                    OUR MISSION
                    <img src={PinkCircle} alt="" />
                  </Typography>
                  <Typography
                    sx={{
                      ...ourmissionotherStyles.typography,
                      "@media (max-width: 491px)": {
                        fontSize: "14px",
                        fontStyle: "normal",
                        lineHeight: "160%",
                        marginTop: "-35px",
                        textAlign: "left",
                      },
                    }}
                  >
                    To bridge the digital divide and unlock limitless
                    possibilities by providing accessible, secure, and powerful
                    cloud technology. We believe everyone deserves the tools to
                    thrive in a connected world, and we're committed to making
                    that vision a reality
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <picture>
                    <source
                      media="(max-width: 600px)"
                      srcSet={OurMissionExtraSmall}
                      width="100%"
                      className="Img-responsive-width"
                    />
                    <source
                      media="(max-width: 1024px)"
                      srcSet={OurMissionSmall}
                      className="Img-responsive-width"
                    />
                    {/* <source
                    media="(max-width: 791px)"
                    srcSet={AboutOurMissionImage}
                    className="Img-responsive-width"
                  /> */}
                    <img
                      src={OurMissionImage}
                      alt=""
                      className="Img-responsive-width"
                    />
                  </picture>
                  {/* <img src={OurMission} alt="" className="Img-responsive-width" /> */}
                  {/* Adjust image width */}
                </Grid>
              </Grid>
           
          </Box>
        </div>
        <div className="OurValues-Section">
          <Box
            sx={{
              // padding: "39px 60px",
              margin: "2%",
              backgroundColor: "#fff",
              // paddingRight: "65px",
              // paddingLeft: "115px",
              // marginRight: "10px",
              "@media (max-width: 1024px) ": {
                paddingRight: "0px",
                paddingLeft: "0px",
                // margin: "41px",
                marginRight: "0px",
                padding: "0px",
              },
              "@media (max-width: 600px)": {
                marginLeft: "7px",
                marginRight: "0px",
              },
            }}
          >
            <Grid
              container
              justifyContent="center"
              spacing={2}
              sx={{
                alignItems: "center",
                borderRadius: "30px",
                // padding: "39px 60px",
                border: "2px solid #1E53E8",

                "@media (max-width: 600px)": {
                  flexDirection: "column-reverse",
                  // height:"auto"
                },
                "@media (max-width: 1024px)": {
                  // padding: "30px 30px 30px 30px",
                  // height: "auto",
                  // marginBottom: "-30px",

                  // marginLeft: "-53px",
                },
              }}
            >
              <Grid
                item
                xs={12}
                md={6}
                
                sx={{
                  
                  paddingLeft:"0px",
                  paddingTop:"0px",
                  "@media (max-width: 1024px)": {
                    paddingLeft: "0px",
                    maxWidth: "60%",
                  },
                  "@media (max-width: 600px)": {
                    paddingLeft: "10px",
                    maxWidth: "100%",
                  },
                }}
              >
                <Box
                  sx={{
                    /*padding: "71px 1px 1px 1px"*/ width: "100%",
                    height: "100%",
                    margin:"6%",
                    "@media (max-width: 600px)": {
                      padding: "0px",
                      display: "flex",
                      justifyContent: "center",
                      height: "100%",
                    },
                    "@media (max-width: 1024px)": {
                      height: "100%",
                      width:"93%",
                      margin:"4%"
                    },
                  }}
                >
                  <picture>
                    {/* <source media="(max-width: 600px)" srcSet={AboutImageSmall} /> */}
                    <source
                      media="(max-width: 1024px)"
                      srcSet={MomSonImageSmall}
                      width="100%"
                      className="Img-responsive-width"
                      height="100%"
                    />
                    {/* <source
                    media="(max-width: 791px)"
                    srcSet={AboutOurMissionImage}
                    className="Img-responsive-width"
                  /> */}
                    <img src={MomSonImage} alt="" />
                  </picture>
                  {/* <img src={MomSonImage} alt="Momson" style={{ width: "100%" }} /> */}
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  padding: "20px",
                  "@media (max-width: 1024px)": {
                    maxWidth: "40%",
                    paddingLeft: "8px",
                    paddingTop: "35px",
                  },

                  "@media (max-width: 600px)": {
                    maxWidth: "100%",
                    paddingLeft: "8px",
                    paddingTop: "35px",
                  },
                }}
              >
                <Typography
                  sx={{
                    ...ourvaluestyle.typography,
                    "@media (max-width: 1024px)": {
                      fontSize: "42px",
                      lineHeight: "100%",
                    },
                  }}
                >
                  Our values
                  <img src={PinkCircle} alt="" style={{}} />
                </Typography>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    height: "150px",
                    "@media (max-width: 1024px)": {
                      height: "90px",
                      marginBottom: "60px",
                    },
                  }}
                >
                  <div>
                    <Box
                      sx={{
                        ...ourvaluestyle.greenCircle,
                      }}
                    >
                      1
                    </Box>
                  </div>
                  <div>
                    <Typography
                      sx={{
                        ...styles.typography,
                        fontSize: "34px",
                        marginTop: "10px",
                        fontWeight: 700,
                        color: "#000000",
                        "@media (max-width: 1024px)": {
                          fontSize: "24px",
                          marginTop: "-23px",
                        },
                      }}
                    >
                      INNOVATION
                    </Typography>
                    <Typography
                      sx={{
                        ...smallDescriptionText.typography,
                        fontSize: "20px",
                        width: "100%",
                        height: "44px",
                        "@media (max-width: 600px)": {
                          fontSize: "16px",
                        },
                        "@media (max-width: 1024px)": {
                          fontSize: "14px",
                          marginBottom: "30px",
                        },
                      }}
                    >
                      We constantly push boundaries, embracing new technologies
                      and ideas to shape the future of cloud experiences.
                    </Typography>
                  </div>
                </Box>

                <br />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    height: "150px",
                  }}
                >
                  <div>
                    <Box
                      sx={{
                        ...ourvaluestyle.greenCircle,
                        "@media (max-width: 1024px)": {
                          marginBottom: "50px",
                        },
                      }}
                    >
                      2
                    </Box>
                  </div>
                  <div>
                    <Typography
                      sx={{
                        ...styles.typography,
                        fontSize: "34px",
                        marginTop: "10px",

                        color: "#000000",
                        fontWeight: 700,
                        "@media (max-width: 600px)": {
                          textAlign: "left",
                        },
                        "@media (max-width: 1024px)": {
                          fontSize: "24px",
                          marginTop: "-51px",
                        },
                      }}
                    >
                      INCLUSIVITY
                    </Typography>
                    <Typography
                      sx={{
                        ...smallDescriptionText.typography,
                        fontSize: "20px",
                        width: "100%",
                        height: "44px",
                        "@media (max-width: 600px)": {
                          fontSize: "16px",
                        },
                        "@media (max-width: 1024px)": {
                          fontSize: "14px",
                          marginBottom: "20px",
                        },
                      }}
                    >
                      We design solutions for everyone, fostering a diverse and
                      welcoming environment where all voices are heard and
                      valued.
                    </Typography>
                  </div>
                </div>
                <br />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    height: "150px",
                  }}
                >
                  <div>
                    <Box
                      sx={{
                        ...ourvaluestyle.greenCircle,
                        "@media (max-width: 1024px)": {
                          marginBottom: "88px",
                        },
                      }}
                    >
                      3
                    </Box>
                  </div>
                  <div>
                    <Typography
                      sx={{
                        ...styles.typography,
                        fontSize: "34px",
                        marginTop: "10px",
                        fontWeight: 700,
                        color: "#000000",
                        "@media (max-width: 1024px)": {
                          fontSize: "24px",
                          marginTop: "-70px",
                        },
                      }}
                    >
                      EXCELLENCE
                    </Typography>
                    <Typography
                      sx={{
                        ...smallDescriptionText.typography,
                        fontSize: "20px",
                        width: "100%",
                        height: "44px",
                        "@media (max-width: 600px)": {
                          fontSize: "16px",
                        },
                        "@media (max-width: 1024px)": {
                          fontSize: "14px",
                        },
                      }}
                    >
                      We strive for unparalleled quality and performance,
                      exceeding expectations and delivering exceptional results.
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>

        <br />
        {/* <div
          style={{
            padding: "40px",
            margin: "20px",
            backgroundColor: "#fff",
            borderRadius: "30px",
            border: "2px solid #1E53E8",
          }}
        >
          <Grid
            container
            justifyContent="center"
            spacing={4}
            sx={{
              alignItems: "center",
              "@media (max-width: 600px)": {
                flexDirection: "column-reverse",
              },
            }}
          >
            <Grid item xs={12} md={6}>
              <div>
                <img src={MomSonImage} alt="Momson" style={{ width: "100%" }} />
              </div>
            </Grid>
            <Grid item xs={12} md={6} sx={{ padding: "20px" }}>
              <Typography sx={ourvaluestyle.typography}>
                Our values
                <img
                  src={PinkCircle}
                  alt=""
                  style={{ padding: "12px", paddingTop: "23px" }}
                />
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  height: "150px",
                }}
              >
                <div>
                  <div
                    style={{
                      ...ourvaluestyle.greenCircle,
                    }}
                  >
                    1
                  </div>
                </div>
                <div>
                  <Typography
                    sx={{
                      ...styles.typography,
                      fontSize: "34px",
                      marginTop: "10px",
                      fontWeight: 700,
                      color: "#000000",
                    }}
                  >
                    INNOVATION
                  </Typography>
                  <Typography
                    sx={{
                      ...smallDescriptionText.typography,
                      fontSize: "20px",
                      width: "100%",
                      height: "44px",
                      "@media (max-width: 600px)": {
                        fontSize: "16px",
                      },
                    }}
                  >
                    We constantly push boundaries, embracing new technologies
                    and ideas to shape the future of cloud experiences.
                  </Typography>
                </div>
              </div>
              <br />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  height: "150px",
                }}
              >
                <div>
                  <div
                    style={{
                      ...ourvaluestyle.greenCircle,
                    }}
                  >
                    2
                  </div>
                </div>
                <div>
                  <Typography
                    sx={{
                      ...styles.typography,
                      fontSize: "34px",
                      marginTop: "10px",
                      fontWeight: 900,
                      color: "#000000",
                      fontWeight: 700,
                      "@media (max-width: 600px)": {
                        textAlign: "left",
                      },
                    }}
                  >
                    INCLUSIVITY
                  </Typography>
                  <Typography
                    sx={{
                      ...smallDescriptionText.typography,
                      fontSize: "20px",
                      width: "100%",
                      height: "44px",
                      "@media (max-width: 600px)": {
                        fontSize: "16px",
                      },
                    }}
                  >
                    We design solutions for everyone, fostering a diverse and
                    welcoming environment where all voices are heard and valued.
                  </Typography>
                </div>
              </div>
              <br />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  height: "150px",
                }}
              >
                <div>
                  <div
                    style={{
                      ...ourvaluestyle.greenCircle,
                    }}
                  >
                    3
                  </div>
                </div>
                <div>
                  <Typography
                    sx={{
                      ...styles.typography,
                      fontSize: "34px",
                      marginTop: "10px",
                      fontWeight: 700,
                      color: "#000000",
                    }}
                  >
                    EXCELLENCE
                  </Typography>
                  <Typography
                    sx={{
                      ...smallDescriptionText.typography,
                      fontSize: "20px",
                      width: "100%",
                      height: "44px",
                      "@media (max-width: 600px)": {
                        fontSize: "16px",
                      },
                    }}
                  >
                    We strive for unparalleled quality and performance,
                    exceeding expectations and delivering exceptional results.
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </div> */}
        {/* MEET OUR TEAM PAGE  */}
        <div className="About-Teams">
          <Box>
            <Typography
              sx={{
                ...styles.typography,
                textAlign: "center",
                color: "#1E53E8",
                // marginTop: "40px",
                position: "relative",
                zIndex: "1",
              }}
            >
              MEET OUR TEAM
              <img src={PinkCircle} alt="" />
            </Typography>
            <Typography
              sx={{
                ...smallDescriptionText.typography,
                fontWeight: 500,
                lineHeight: "26px",
                textAlign: "center",
                position: "relative",
                zIndex: "1",
              }}
            >
              Get to know the minds behind the cloud and the dedication they
              bring to every project.
            </Typography>

            <img
              src={CircularRound}
              alt=""
              style={{ position: "absolute", right: "0", top: "0" }}
            />
            <Box
              sx={{
                // backgroundColor: "#f1f1f1",
                // padding: "20px",
                // borderRadius: "15px",
                // position: "relative",
                // zIndex: "1",
                marginTop: "50px",
              }}
            >
              <Grid container spacing={2}>
                {/* <Grid item xs={6} md={12} sm={12}> */}

                {/* </Grid> */}
              </Grid>
            </Box>
          </Box>
        </div>
        <TrendingSwiper />
        <br />

      </div>
        <FooterLandingpage />
    </div>
  );
}

export default AboutCompany;
